import ViewGroups from "../components/Group/ViewGroups";

const GroupsPage: React.FC = () => {
  return <ViewGroups />;
};

export default GroupsPage;
